import SidebarCollapsableItem from "./SidebarCollapsableItem";

const SidebarLinks = ({ sidebarLinks, sidebarCollapsed }) => {
  return (
    <div
      className="mdk-drawer js-mdk-drawer tw-transition-all tw-duration-200 tw-hidden md:tw-block"
      id="default-drawer"
      data-persistent
      data-opened
      style={{ width: `${sidebarCollapsed ? "0" : ""}` }}
    >
      <div
        className="tw-relative mdk-drawer__content tw-z-50 tw-h-full !tw-top-[61px] !tw-transition-all !tw-duration-200"
        style={{ left: `${sidebarCollapsed ? "-256px" : ""}` }}
      >
        <div
          className="sidebar sidebar-left !tw-text-secondary tw-bg-primary o-hidden custom-sidebar tw-flex tw-flex-col tw-justify-between tw-py-4 !tw-overflow-hidden"
          data-perfect-scrollbar=""
        >
          <div className="px-2">
            {sidebarLinks?.map((sidebarItem, index) => (
              <div key={index}>
                <SidebarCollapsableItem sidebarItem={sidebarItem} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarLinks;
